<template>
  <v-card flat class="mx-auto">
    <v-card-text align="center" justify="center" :class="textStyle">
      {{ headline }}
    </v-card-text>
    <v-row class="mx-4 mb-4 mt-n8" align="center" justify="center">
      <v-col v-for="logo of logos" :key="logo" class="d-flex child-flex" cols="4" sm="3" md="2">
        <image-on-hover-change-color class="mx-4" :src="logo" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import ImageOnHoverChangeColor from "@/components/utility/ImageOnHoverChangeColor.vue";

@Component({
  components: {
    ImageOnHoverChangeColor
  }
})
export default class KnownFormCard extends Vue {
  @Prop({ default: 800 })
  maxWidth!: number;

  @Prop()
  headline!: "";

  @Prop()
  logos!: string[];

  @Prop({ default: "text-caption font-weight-light font-italic" })
  textStyle!: string[];
}
</script>
